import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'site-shipping-loader',
    template: require('./site-shipping-loader.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteShippingLoaderComponent {

    constructor( ) {
    }
}